import { useEffect, useState } from 'react';
import { auth, db } from './lib/firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore';

import AuthScreen    from './screens/AuthScreen';
import HomeScreen    from './screens/HomeScreen';
import ChatScreen    from './screens/ChatScreen';
import VoiceScreen   from './screens/VoiceScreen';
import VibesScreen   from './screens/VibesScreen';
import ExpenseScreen from './screens/ExpenseScreen';

export default function App() {
  const [user, setUser]         = useState(undefined); // undefined = loading
  const [userData, setUserData] = useState(null);
  const [tab, setTab]           = useState('home');

  // Auth listener
  useEffect(() => {
    return onAuthStateChanged(auth, u => setUser(u || null));
  }, []);

  // User data listener + presence
  useEffect(() => {
    if (!user) return;
    const ref = doc(db, 'users', user.uid);
    // Mark online
    setDoc(ref, { online: true, lastSeen: serverTimestamp() }, { merge: true });
    // Listen for profile
    const unsub = onSnapshot(ref, snap => {
      if (snap.exists()) setUserData(snap.data());
    });
    // Mark offline on unload
    const markOffline = () => setDoc(ref, { online: false, lastSeen: serverTimestamp() }, { merge: true });
    window.addEventListener('beforeunload', markOffline);
    return () => { unsub(); window.removeEventListener('beforeunload', markOffline); };
  }, [user]);

  if (user === undefined) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div style={{ color: 'var(--text-muted)', fontSize: 24 }}>🏠</div>
      </div>
    );
  }

  if (!user) return <AuthScreen />;

  const screens = {
    home:    <HomeScreen    user={user} userData={userData} onNavigate={setTab} />,
    chat:    <ChatScreen    user={user} userData={userData} onNavigate={setTab} />,
    voice:   <VoiceScreen   user={user} userData={userData} />,
    vibes:   <VibesScreen   user={user} userData={userData} />,
    expense: <ExpenseScreen user={user} userData={userData} />,
  };

  const navItems = [
    { id: 'home',    icon: 'ti-home-2',         label: 'home'   },
    { id: 'chat',    icon: 'ti-message-circle-2', label: 'chats'  },
    { id: 'voice',   icon: 'ti-microphone-2',   label: 'voice'  },
    { id: 'vibes',   icon: 'ti-sparkles',        label: 'vibes'  },
    { id: 'expense', icon: 'ti-receipt-2',       label: 'splits' },
  ];

  return (
    <>
      {screens[tab]}

      <nav className="bottom-nav">
        {navItems.map(n => (
          <button
            key={n.id}
            className={`nav-btn${tab === n.id ? ' active' : ''}`}
            onClick={() => setTab(n.id)}
          >
            <i className={`ti ${n.icon}`} />
            <span>{n.label}</span>
            <div className="nav-dot" />
          </button>
        ))}
      </nav>
    </>
  );
}
